function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { useMediaQuery } from "@material-ui/core";
import MuiAlert from "@mui/material/Alert";
import React, { useEffect, useState } from "react";
import Property from "../Property";
import useData from "./data";
import ProjectMapLoadingUI from "../../../Common/LoadingUI";
import Pagination from "../../../Common/Pagination";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var Alert = /*#__PURE__*/React.forwardRef(function Alert(props, ref) {
  return /*#__PURE__*/_jsx(MuiAlert, _objectSpread({
    elevation: 6,
    ref: ref,
    variant: "filled"
  }, props));
});
var PropertyMapView = function PropertyMapView(props) {
  var _config$projects;
  var isMapView = props.isMapView;
  var theme = props.theme;
  var screenBelowLg = useMediaQuery(theme.breakpoints.down("lg"));
  var config = props.config;
  var appType = props.appType;
  var projects = props.projects,
    projectsHeading = props.projectsHeading,
    loadingProjects = props.loadingProjects,
    totalPages = props.totalPages,
    currentPage = props.currentPage,
    onPageChange = props.onPageChange,
    propertyBackgroundColorWithOverlay = props.propertyBackgroundColorWithOverlay,
    viewMapHandler = props.viewMapHandler,
    mapViewActive = props.mapViewActive;
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    projectId = _useState2[0],
    setProjectId = _useState2[1];
  var _useData = useData({
      winnreNoAuth: props.winnreNoAuth
    }),
    getProjectLocation = _useData.getProjectLocation,
    lng = _useData.lng,
    lat = _useData.lat,
    viewport = _useData.viewport,
    setViewport = _useData.setViewport;
  useEffect(function () {
    if (screenBelowLg && isMapView) {
      var _props$onForceList;
      (_props$onForceList = props.onForceList) === null || _props$onForceList === void 0 || _props$onForceList.call(props);
    }
  }, [screenBelowLg]);
  return /*#__PURE__*/_jsxs("div", {
    className: "w-full",
    children: [loadingProjects && /*#__PURE__*/_jsx(ProjectMapLoadingUI, {
      className: "w-full flex items-start flex-col animate-bounce mt-7"
    }), !loadingProjects && /*#__PURE__*/_jsxs("div", {
      children: [(projects === null || projects === void 0 ? void 0 : projects.length) === 0 && !loadingProjects && /*#__PURE__*/_jsx("div", {
        className: "flex",
        children: /*#__PURE__*/_jsx("p", {
          className: "z-10 p-2 lg:w-[45%] xl:w-[50%] ".concat(config === null || config === void 0 || (_config$projects = config.projects) === null || _config$projects === void 0 || (_config$projects = _config$projects.moduleConfig) === null || _config$projects === void 0 ? void 0 : _config$projects.fontTitle),
          style: {
            backgroundColor: config === null || config === void 0 ? void 0 : config.primaryColor,
            color: "white"
          },
          children: "Sorry, No Projects To Show"
        })
      }), /*#__PURE__*/_jsx("div", {
        className: "grid gap-x-10 pr-4 mb-5 h-[90vh] scrollbar-thumb-rounded-full scrollbar-track-rounded-full scrollbar-thin scrollbar-thumb-primary scrollbar-track-gray-200 overflow-y-scroll content-start ".concat(isMapView ? " grid-cols-1 gap-y-5" : "lg:grid-cols-2 gap-y-10 md:gap-y-4 ", " z-10"),
        children: projects === null || projects === void 0 ? void 0 : projects.map(function (project, i) {
          var _project$apartment, _project$apartment2;
          return /*#__PURE__*/_jsx("div", {
            children: /*#__PURE__*/_jsx(Property, {
              isMapView: isMapView,
              setProjectId: setProjectId,
              projectId: project.id,
              projectName: project.projectName,
              projectDescription: (project === null || project === void 0 ? void 0 : project.projectDescription) === null ? "" : project === null || project === void 0 ? void 0 : project.projectDescription,
              projectCity: project.city,
              projectState: project.state,
              projectPrice: project.price,
              projectLogo: project.projectLogo,
              projectBackground: project.projectBgImage,
              projectStatus: project.status,
              projectApartmentSize: (project === null || project === void 0 || (_project$apartment = project.apartment) === null || _project$apartment === void 0 ? void 0 : _project$apartment.charAt(0)) === "0" ? project === null || project === void 0 || (_project$apartment2 = project.apartment) === null || _project$apartment2 === void 0 ? void 0 : _project$apartment2.substring(2) : project === null || project === void 0 ? void 0 : project.apartment,
              setViewport: setViewport,
              viewport: viewport,
              getProjectLocation: getProjectLocation,
              onClick: viewMapHandler,
              mapViewActive: mapViewActive,
              propertyBackgroundColorWithOverlay: propertyBackgroundColorWithOverlay,
              currentPage: currentPage,
              projectLocation: project.projectLocation,
              projectType: project.type,
              config: config,
              appType: appType,
              onNavigateToDetail: props.onNavigateToDetail
            })
          }, i);
        })
      }), /*#__PURE__*/_jsxs("div", {
        className: "flex flex-col lg:flex-row justify-between items-center mb-6",
        children: [/*#__PURE__*/_jsxs("p", {
          className: "font-semibold self-start mb-7 lg:mb-0 text-sm xl:text-base ",
          children: ["Showing ", currentPage, " out of ", totalPages]
        }), /*#__PURE__*/_jsx(Pagination, {
          totalPages: totalPages,
          currentPage: currentPage,
          onPageChange: onPageChange,
          scrollTo: "project_section",
          config: config
        })]
      })]
    })]
  });
};
export default PropertyMapView;